/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parametersFirstCreateScreen from '@jira/ai-first-create__app/src/__generated__/FirstCreateScreenQuery$parameters';
import type { FirstCreateViewQuery } from '@jira/ai-first-create__app/src/__generated__/FirstCreateViewQuery.graphql.ts';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type PreloadQueries = {
	firstCreateQueryRef: FirstCreateViewQuery;
};

type ExtraProps = {
	projectIdOrKey: string;
	theme: 'light' | 'dark';
};

type AiFirstCreateEntryPointComponent = EntryPointComponent<PreloadQueries, {}, {}, ExtraProps>;

export const aiFirstCreateEntryPoint: EntryPoint<
	AiFirstCreateEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<AiFirstCreateEntryPointComponent>(
		/* webpackChunkName: "async-ai-first-create-entrypoint" */ './AIFirstCreateComponent.tsx',
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const { context, tenantContext } = entryPointRouteParams;
		const { cloudId } = tenantContext;

		const projectIdOrKey = String(context.query?.projectIdOrKey ?? '');
		let theme: 'light' | 'dark' = 'light';
		if (context.query?.theme === 'dark') {
			theme = 'dark';
		}

		return {
			queries: {
				firstCreateQueryRef: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters: parametersFirstCreateScreen,
					variables: {
						cloudId,
						projectIdOrKey,
					},
				},
			},
			entryPoints: {},
			extraProps: {
				projectIdOrKey,
				theme,
			},
		};
	},
});
